var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiogasSystem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lunch_dining_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20.6 C0,22.47 1.17,24 2.6,24 L23.4,24 C24.83,24 26,22.47 26,20.6 L26,7 L0,7 L0,20.6 Z M1.79310345,8.88888889 L24.2068966,8.88888889 L24.2068966,22.1111111 L1.79310345,22.1111111 L1.79310345,8.88888889 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9998654,0 C5.57694228,0 0,2.57142857 0,7.71428571 L0,9 L25.9999109,9 L25.9999109,7.71428571 C26.0257306,2.57142857 20.4357885,0 12.9998654,0 Z M2.68963668,6.3 C3.78255205,3.015 8.52290788,1.8 12.986743,1.8 C17.3452368,1.8 20.7951624,2.895 22.454287,4.785 C22.8493166,5.25 23.139005,5.745 23.3101845,6.3 L2.68963668,6.3 Z M2.68963668,6.3 L23.3101845,6.3 L23.3101845,7.2 L2.68963668,7.2 L2.68963668,6.3 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.9661698,11.0006737 L38,11 L37.9996983,23.178 L36.2066983,23.178 L36.206,13 L24.3921558,13.0009175 C24.4470888,12.3264461 24.5224164,11.6595495 24.6181386,11.0002278 L35.31,11 L35.3101845,10.3 L35.2296046,10.0657289 C35.0540871,9.60418367 34.7928838,9.18357143 34.454287,8.785 C32.7951624,6.895 29.3452368,5.8 24.986743,5.8 L24.8762607,5.80037206 C24.6540775,5.16415989 24.29989,4.57132996 23.8136983,4.02188228 C24.2032852,4.00750374 24.5988819,4 24.9998654,4 C32.083513,4 37.4919426,6.33355791 37.9661698,11.0006737 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2,
    y: 22,
    width: 36,
    height: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiogasSystem);
export default __webpack_public_path__ + "static/media/biogas_system.667ec71a5c375ca709987f9eca9f9cda.svg";
export { ForwardRef as ReactComponent };